import React, {useEffect, useState} from "react";
import "./styles.css"
import {TRAVEL_OPTION_TYPE} from "../../types-enums/activity";
import Fuse from "fuse.js";
import {Button, Icon, Text} from "atmosfair-ui";
import groupBy from "lodash/groupBy";
import {useTranslation} from "react-i18next";
import {ACTIVITY_OPTIONS, ActivityOptionsProps} from "../../constants/default-values";
import BottomButtons from "../button-groups/bottom-buttons/BottomButtons";
import {generateJourneyDayCountToolTip, generateTravelComponentCountToolTip} from "../../utils/string/tooltips";
import {PATH_SCREEN_STRING, PATH_STRINGS} from "../../routes/route-props";
import {useNavigate} from "react-router-dom";
import {useAppSelector} from "../../redux/reducer/store";
import TopButtonsWrapper from "../button-groups/top-buttons-wrapper/TopButtonsWrapper";
import LoadBundlesButton from "../../container/buttons/load-bundles-button/LoadBundlesButton";
import {ACTIVITY_ICON_MAPPING} from "../../utils/getter/activities";
import {BundleType} from "../../container/buttons/common";

const SelectActivityForCalculation = () => {
    const [fuse, setFuse] = useState<Fuse<ActivityOptionsProps> | null>(null)
    const [activityOptions, setActivityOptions] = useState<ActivityOptionsProps[]>(ACTIVITY_OPTIONS)
    const groupedActivityOptions = groupBy(activityOptions, "travelOptionType")
    const {activities: travelComponentsActivities} = useAppSelector(state => state.travelComponents)
    const {activities: journeyActivities} = useAppSelector(state => state.journey)
    const {journeyDuration} = useAppSelector(state => state.journey)
    const {t, i18n} = useTranslation()
    const {resolvedLanguage} = i18n
    const navigate = useNavigate()

    useEffect(() => {
        const translatedActivityOptionsForFuse = ACTIVITY_OPTIONS.map(activityOption => {
            return {...activityOption, title: t(activityOption.title)}
        })
        setFuse(new Fuse<ActivityOptionsProps>(translatedActivityOptionsForFuse, {
            keys: ['title'],
            minMatchCharLength: 1,
            location: 0,
            threshold: 0.5,
            distance: 10,
        }))
    }, [resolvedLanguage])

    // const _onChange = (searchString: string) => {
    //     if (searchString.length > 0 && fuse) {
    //         setActivityOptions(fuse
    //             .search(searchString)
    //             .map(({item}) => item)
    //         )
    //     } else {
    //         setActivityOptions(ACTIVITY_OPTIONS)
    //     }
    // }

    return <>
        <TopButtonsWrapper rightButtons={<LoadBundlesButton
            showBundleIcon={false}
            whatToLoad={BundleType.travelComponents}/>}/>
        <div className={"select-activity-for-calculation"}>
            {/*SEARCH OPTION CURRENTLY NO NEEDED. TURN ON ONCE NEEDED*/}
            {/*<section className={"select-activity-for-calculation-activity-search-wrapper"}>*/}
            {/*    <Text*/}
            {/*        style={{width: "100%"}}*/}
            {/*        // ariaFor={searchLabelFor}*/}
            {/*        variant={"headlineSmall"}>*/}
            {/*        SCREENS.SELECT_TRAVEL_COMPONENTS.SEARCH_BAR_LABEL*/}
            {/*    </Text>*/}
            {/*    <input*/}
            {/*        style={{width: "30%"}}*/}
            {/*        // id={searchLabelFor}*/}
            {/*        autoFocus={true}*/}
            {/*        placeholder={`${t("GENERAL.SEARCH")}...`}*/}
            {/*        onChange={event => _onChange(event.target.value)}*/}
            {/*        type={"search"}/>*/}
            {/*</section>*/}
            {(Object.keys(groupedActivityOptions) as Array<TRAVEL_OPTION_TYPE>).map((travelOptionType, index) => {
                return <section
                    key={index}
                    className={"select-activity-for-calculation-option-wrapper"}>
                    <Text variant={"headlineMedium"}>{`TRAVEL_OPTIONS.${travelOptionType.toUpperCase()}.TITLE`}</Text>
                    <div className={"select-activity-for-calculation-activity-card-wrapper"}>
                        {groupedActivityOptions[travelOptionType].map((activityOption, index) => {
                            const {title, activityType} = activityOption
                            return <Button
                                key={index}
                                onClick={() => navigate(`${PATH_STRINGS.addActivityToTravelComponents}/${PATH_SCREEN_STRING.tc}/${activityType}/`)}
                                containerClasses={"select-activity-for-calculation-activity-card-button"}>
                                <Icon size={"small"} icon={ACTIVITY_ICON_MAPPING[activityType]}/>
                                <Text
                                    toUpperCase={true}
                                    color={"white"}
                                    variant={"headlineMedium"}>
                                    {title}
                                </Text>
                            </Button>
                        })
                        }
                    </div>
                </section>
            })
            }
        </div>
        <BottomButtons buttons={[
            {
                text: "GENERAL.ABORT",
                variant: "abort",
                onClick: () => navigate(-1)
            },
            {
                style: {marginLeft: "auto"},
                tooltip: generateTravelComponentCountToolTip(travelComponentsActivities, i18n),
                text: "SCREENS.COMMON.GO_TO_TRAVEL_COMPONENTS",
                onClick: () => navigate(PATH_STRINGS.travelComponentsOverview),
            },
            {
                tooltip: generateJourneyDayCountToolTip(journeyDuration, journeyActivities, i18n),
                text: "SCREENS.COMMON.GO_TO_JOURNEY",
                onClick: () => navigate(PATH_STRINGS.journey),
            }
        ]}/>
    </>
}

export default SelectActivityForCalculation